module.exports = __webpack_public_path__ + "static/media/tiger.7d815bd9.jpg";